<template>
  <div>

    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
        </div>
        <div class="container shape-container d-flex">
          <div class="align-items-center row">
            <div class="col-lg-4 mr-auto text-left mt-4">
              <div class="border-0 home-image">
                <img src="/img/image/mockup_1-1.png" class="card-img-top">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="col">
                <div class="position-relative">
                  <img src="/img/brand/message.svg" class="img-center img-fluid">
                  <div class="text-main-color position-absolute message">
                    輕鬆設計亞克力板，保存珍貴回憶！
                  </div>
                </div>
                <div class="mt-sm text-white h2">
                  不需任何修圖技能，一鍵設計 簡單DIY！
                </div>
                <div class="row mt-lg">
                  <a :href="app_store_url" target="_blank" class="img-center img-fluid"><img src="/img/brand/app_store.png"></a>
                  <a :href="google_play_url" target="_blank" class="img-center img-fluid"><img src="/img/brand/google_play.png"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->

      <section id="gallery" class="section section-sm mt--300 mb-150">
        <div class="container">
          <div class="row row-grid align-items-center ">
            <div class="col-md-6 order-md-2">
              <!--              <img src="img/theme/promo-1.png" class="img-fluid floating">-->

              <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="d-block w-100" src="img/image/2-1.jpg" alt="First slide">
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="img/image/2-2.jpg" alt="Second slide">
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="img/image/2-3.jpg" alt="Third slide">
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>

            <div class="col-md-6 order-md-1">
              <div class="pr-md-5">
                <h3 class="text-main-color">特色模板 輕鬆上手</h3>
                <p>追星小卡 到 實用日曆<br>沒有經驗 也能成為 DIY高手</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div id="design"></div>
      <section class="section  section-lg  has-cards">
        <div class="container">
          <div class="row justify-content-center text-center mb-sm">
            <div class="col-lg-8">
              <h2 class="display-3">設計獨一無二 亞克力板</h2>
            </div>
          </div>
        </div>
        <div class="row row-cols-1">
          <div class="col-md-12 col-md-6">
            <Glide></Glide>
          </div>
        </div>
      </section>

      <section id="about_us" class="section section-sm">
        <div class="container">
          <div class="row justify-content-center text-center mb-lg">
            <div class="col-lg-8">
              <h2 class="display-3">關於 Snapture</h2>
              <p class="lead text-muted">
                Snapture是一個提供亞克力膠板DIY設計的平台，您可以自由使用喜愛的相片、貼圖和文字客製成獨一無二的亞克力板，並打印成鎖匙圈或立牌等，保存最珍貴的回憶，時刻帶在身邊！</p>
            </div>
          </div>
          <div class="container">
            <div class="align-items-center row">
              <div class="col-lg-5 mr-auto text-left mt-4 mb-5">
                <div class="card bg-main-color shadow border-0">
                  <img src="/img/image/5-1.jpg" class="card-img-top">
                </div>
              </div>

              <div class="p-sm-0 col-lg-6">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="info info-hover-warning">
                      <img src="/img/icons/common/Component%2033%20–%201.png" class="icon-lg">
                      <h5 class="info-title">一鍵去除背景</h5>
                      <p class="description">上傳喜愛相片<br>
                        AI技術 無痕去除背景<br>
                        輕鬆剪裁 免去繁瑣工序<br>
                      </p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="info info-hover-info">
                      <img src="/img/icons/common/Component%2034%20–%202.png" class="icon-lg">
                      <h5 class="info-title">特色模板 輕鬆上手</h5>
                      <p class="description">追星小卡 到 實用日曆<br>
                        沒有經驗 也能成為 DIY高手</p></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="info info-hover-danger">
                      <img src="/img/icons/common/Component%2035%20–%202.png" class="icon-lg">
                      <h5 class="info-title">多款配件 自由添購</h5>
                      <p class="description">特別版鎖匙扣<br>獨一無二風格</p></div>
                  </div>
                  <div class="col-sm-6">
                    <div class="info info-hover-success">
                      <img src="/img/icons/common/Component%2036%20–%202.png" class="icon-lg">
                      <h5 class="info-title">無限創意 盡在指尖</h5>
                      <p class="description">三個尺寸 自由選擇<br>
                        打印圖案數量不限<br>
                        過百款 貼圖/形狀/文字增添特色
                        </p></div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <div id="faq"></div>
      <section class="section section-sm has-cards">
        <div class="container">
          <div class="row justify-content-center text-center mb-sm">
            <div class="col-lg-8">
              <h2 class="display-3">FAQ</h2>
            </div>
          </div>
          <div class="accordion-1">
            <div class="container">
              <div class="row">
                <div class="col-md-12 ml-auto">
                  <div class="accordion my-3" id="accordionExample">
                    <div class="card" v-for="(item) in questions" :key="item.id">
                      <div class="card-header p-0" :id="`heading-${item.id}`">
                        <h5 class="mb-0">
                          <button class="btn btn-link w-100 text-custom-text text-left p-sm" type="button"
                                  data-toggle="collapse" :data-target="`#collapse-${item.id}`" aria-expanded="false"
                                  :aria-controls="`collapse-${item.id}`"
                                  style="word-break: break-all; white-space: normal;"
                          >
                            {{ item.question }}
                            <i class="ni ni-bold-down float-right text-custom-purple"></i>

                          </button>
                        </h5>
                      </div>

                      <div :id="`collapse-${item.id}`" class="collapse" :aria-labelledby="`heading-${item.id}`"
                           data-parent="#accordionExample">
                        <div class="card-body text-custom-description">
                          {{ item.answer }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import Glide from "@/components/Glide";
import axios from "axios";
import {VUE_APP_APIPATH} from "@/plugins/globals";

export default {
  name: "home",
  components: {Glide: Glide},
  data() {
    return {
      app_store_url: 'https://apps.apple.com/hk/app/snapture/id6449776138',
      google_play_url: 'https://play.google.com/store/apps/details?id=com.snapture.editor',
      questions: [],
    };
  },
  watch: {
    $route(to, from) {
      console.log("$route to ", to) // 目的地
      console.log("$route from ", from) // 原地
    }
  },
  created() {
    this.getQuestions();
  },
  methods: {
    async getQuestions() {
      let response = await axios.get(`${VUE_APP_APIPATH}question_and_answer?limit=1000`);
      let {rows, count} = response.data;
      this.questions = rows;
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  //  background: url("/img/brand/message.svg");
  //  background-repeat: no-repeat;
  //  background-position: center;
  top: 45%;
  left: 51%;
  transform: translate(-50%, -50%);
  font-size: 1.75rem;
  width: 450px;
}

.mb-150 {
  margin-bottom: 150px;
}

.info-title {
  margin-top: 15px;
  color: rgb(136, 152, 170);
}

.description {
  color: rgb(136, 152, 170);
}

@media (max-width: 570px) {
  .message {
    left: 53%;
    font-size: 1.6rem;
  }
}

@media (max-width: 500px) {
  .message {
    width: 100%;
    font-size: 1.4rem;
  }
}

@media (max-width: 470px) {
  .message {
    font-size: 1.3rem;
  }
}

@media (max-width: 410px) {
  .message {
    font-size: 1.1rem;
  }
}

@media (max-width: 360px) {
  .message {
    font-size: 1.0rem;
  }
}


@media (max-width: 330px) {
  .message {
    font-size: 0.9rem;
  }
}

</style>
